module.exports = __webpack_public_path__ + "img/default-zb.568087fb.png";